<template>
  <div style="padding-bottom: 1px" class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="search">
      <div class="searchbox">
        <div class="item">
          <span>提现时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 225px; margin-left: 6px"
            clearable
            @change="search"
          ></el-date-picker>
        </div>
        <div class="item">
          <span>医生姓名</span>
          <el-input
            placeholder="请输入"
            v-model="doctor_name"
            style="width: 110px; margin-left: 6px"
            @input="search"
            clearable
          ></el-input>
        </div>
        <div class="item">
          <span>手机号</span>
          <el-input
            placeholder="请输入"
            v-model="phone"
            style="width: 110px; margin-left: 6px"
            @input="search"
            clearable
          ></el-input>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981; margin-left: 6px"
            @click="search"
            >查询</el-button
          >
        </div>
        <div class="item" style="margin-right: 50px">
          <span style="margin-right: 6px">提现方式</span>
          <el-radio v-model="cash_type" :label="''" @change="search"
            >全部</el-radio
          >
          <el-radio v-model="cash_type" :label="3" @change="search"
            >微信提现</el-radio
          >
          <el-radio v-model="cash_type" :label="2" @change="search"
            >银行卡提现</el-radio
          >
          <el-radio v-model="cash_type" :label="5" @change="search"
            >绿色通道转账</el-radio
          >
        </div>
        <div class="item" style="margin-right: 50px">
          <span style="margin-right: 6px">提现来源</span>
          <el-select v-model="source_type" clearable @change="search">
            <el-option label="全部" :value="''"></el-option>
            <el-option label="歧黄医官" :value="1"></el-option>
            <el-option label="歧黄学堂" :value="2"></el-option>
          </el-select>
        </div>
        <div class="item" v-if="admin_id == 1">
          <span style="margin-right: 10px">是否测试医生</span>
          <el-radio-group v-model="is_test" @change="search">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="display: flex; align-items: center">
        <el-button
          type="primary"
          @click="showtext"
          v-print="'#printTest'"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('127') : false
          "
          >打印</el-button
        >
        <el-button
          type="primary"
          @click="excelexport"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('127') : false
          "
          >导出</el-button
        >
      </div>
    </div>

    <div style="border: solid 1px #c9cbd6">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; min-width: 1000px"
        :header-cell-style="{ background: '#F5F5F5' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"></el-table-column>

        <el-table-column label="医生信息">
          <template slot-scope="scope">
            <div
              @click="showDocMsg(scope.row.doctor_id)"
              style="cursor: pointer"
            >
              {{ scope.row.doctor_name }}
            </div>
            <div>
              <span>{{ scope.row.sex == 1 ? "男" : "女" }}</span>
              <span style="margin-left: 10px">{{ scope.row.title }}</span>
            </div>
            <div>{{ scope.row.phone }}</div>
          </template>
        </el-table-column>
        <el-table-column label="提现方式">
          <template slot-scope="scope">
            {{ scope.row.type | typeText }}
          </template>
        </el-table-column>

        <el-table-column label="提现来源">
          <template slot-scope="scope">
            <div>{{ scope.row["source_type"] | sourceTypeText }}</div>
          </template>
        </el-table-column>

        <el-table-column label="微信账号" prop="wx_nick_name"></el-table-column>
        <el-table-column label="银行卡号" prop="bank_account"></el-table-column>
        <el-table-column label="开户行" prop="bank_name"></el-table-column>
        <el-table-column label="提现时间">
          <template slot-scope="scope">
            <div :style="scope.row.is_overtime ? 'color:#f2583e' : ''">
              {{ scope.row.create_time }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提现金额" prop="ca_money"></el-table-column>
        <el-table-column
          label="提现手续费"
          prop="service_charge"
        ></el-table-column>
        <el-table-column label="付款金额" prop="pay_money"></el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
      style="margin: 20px 0"
    ></el-pagination>
    <!-- 打印 -->
    <div id="printTest">
      <div ref="printtext" style="display: none">
        <div
          class="audit_sheet"
          v-for="(item, index) in selection"
          :key="index"
        >
          <div class="title item">支 付 审 核 单</div>
          <div class="item">
            <div class="border_right width_23">付款单位：</div>
            <div
              class="border_right width_50"
              style="text-align: left; padding-left: 10px"
            >
              洞子口医院
            </div>
            <div class="width_27">
              附单据
              <span style="margin: 0 10px"></span>
              张
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">付款日期：</div>
            <div class="border_right width_50 flex">
              <div
                class="border_right"
                style="width: 70%; text-align: left; padding-left: 10px"
              >
                {{ item.now_time }}
              </div>
              <div style="width: 30%">预算编号/预算外</div>
            </div>
            <div class="width_27"></div>
          </div>
          <div class="item">
            <div class="border_right width_23">付款依据(发票/合同)：</div>
            <div class="border_right width_50 flex">
              <div
                class="border_right"
                style="
                  width: 70%;
                  font-weight: 700;
                  text-align: left;
                  padding-left: 10px;
                "
              >
                根据歧黄医官平台医生收益策略
              </div>
              <div style="width: 30%">付款方式</div>
            </div>
            <div
              class="width_27 flex_between"
              style="padding: 0 4px; box-sizing: border-box"
            >
              <span>
                现金
                <img :src="border" alt style="width: 13px" />
              </span>
              <span>
                转账
                <img :src="check" alt style="width: 13px" />
              </span>
              <span>
                票据
                <img :src="border" alt style="width: 13px" />
              </span>
              <span>
                其他
                <img :src="border" alt style="width: 13px" />
              </span>
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">收款单位/个人：</div>
            <div style="padding-left: 10px; box-sizing: border-box">
              {{ item.doctor_name }}
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">付款用途：</div>
            <div style="padding-left: 10px; box-sizing: border-box">
              歧黄医官医生个人收益提现
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">收款方开户行：</div>
            <div class="border_right width_50 flex">
              <div
                class="border_right"
                style="width: 70%; text-align: left; padding-left: 10px"
              >
                {{ item.bank_name }}{{ item.bank_branch }}
              </div>
              <div style="width: 30%">账号</div>
            </div>
            <div class="width_27">{{ item.bank_account }}</div>
          </div>
          <div class="item">
            <div class="border_right width_23">①</div>
            <div class="border_right width_50" style="text-align: right">
              (合同/发票)总价款为：
            </div>
            <div class="width_27" style="padding-left: 7%; text-align: left">
              ¥{{ item.pay_money }}
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">②</div>
            <div class="border_right width_50" style="text-align: right">
              此前,已支付的总额为：
            </div>
            <div class="width_27" style="padding-left: 7%; text-align: left">
              ¥0
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">③</div>
            <div class="border_right width_50" style="text-align: right">
              本次付款总额为：
            </div>
            <div class="width_27" style="padding-left: 7%; text-align: left">
              ¥{{ item.pay_money }}
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">④=①-②-③</div>
            <div class="border_right width_50" style="text-align: right">
              本次付后剩余价款为：
            </div>
            <div class="width_27" style="padding-left: 7%; text-align: left">
              ¥0
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">合计金额(大写)：</div>
            <div class="border_right width_50 flex">
              <div class="border_right" style="width: 70%">
                {{ item.pay_money_chinese }}
              </div>
              <div style="width: 30%">合计：</div>
            </div>
            <div class="width_27" style="padding-left: 7%; text-align: left">
              ¥{{ item.pay_money }}
            </div>
          </div>
          <div class="item">
            <div class="border_right width_23">直接经办部门</div>
            <div class="border_right width_50 flex">
              <div class="border_right" style="width: 33%">经办人：</div>
              <div class="border_right" style="width: 37%"></div>
              <div style="width: 30%">部门负责人：</div>
            </div>
            <div class="width_27"></div>
          </div>
          <div class="item">
            <div class="border_right width_23">公司领导</div>
            <div class="border_right width_50 flex">
              <div class="border_right" style="width: 33%">
                分管负责人/院长：
              </div>
              <div class="border_right" style="width: 37%"></div>
              <div style="width: 30%">董事长：</div>
            </div>
            <div class="width_27"></div>
          </div>
          <div class="item">
            <div class="border_right width_23">财务部</div>
            <div class="border_right width_50 flex">
              <div class="border_right" style="width: 20%">会计：</div>
              <div class="border_right" style="width: 26.2%"></div>
              <div style="width: 23.3%" class="border_right">财务负责人：</div>
              <div style="width: 25%"></div>
            </div>
            <div class="width_27 flex">
              <div class="border_right" style="width: 35%">出纳：</div>
              <div style="width: 65%"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import doctor_fee from "../../../api/doctor_fee";
import moment from "moment";
import changeNum from "./changeNum";
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
import print from "vue-print-nb";
export default {
  data() {
    return {
      date: [],
      is_overtime: "",
      doctor_name: "",
      phone: "",
      tableData: [],
      selection: [],
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      is_test: 2,
      cash_type: "",
      source_type: "",
      border: require("@/assets/img/border.png"),
      check: require("@/assets/img/check.png"),
      doc_msg: false,
      doctorId: "",
    };
  },
  directives: {
    print,
  },
  components: {
    DocMsg,
  },
  filters: {
    sourceTypeText(val) {
      switch (val) {
        case 1:
          return "歧黄医官";

        case 2:
          return "歧黄学堂";
      }
    },
    typeText(val){
      switch (val) {
        case 2:
          return '银行卡提现';
        case 3:
          return '微信提现';
        case 5:
          return '绿色通道转账';
          case 8:
          return '微信提现';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        payment_status: 2,
        doctor_name: this.doctor_name,
        phone: this.phone,
        is_overtime: this.is_overtime,
        start_time: "",
        end_time: "",
        is_test: this.is_test,
        cash_type: this.cash_type,
        source_type: this.source_type,
      };
      if (this.date && this.date.length > 0) {
        data.start_time = moment(this.date[0]).format("YYYY-MM-DD");
        data.end_time = moment(this.date[1]).format("YYYY-MM-DD");
      }
      doctor_fee.getCashoutList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = platform.timestampToTime(item.create_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.selection = val.map((item) => {
        item.pay_money_chinese = changeNum.convertCurrency(
          Number(item.pay_money)
        );
        let date = new Date();
        item.now_time = dayjs(date).format("YYYY年MM月DD日");
        return item;
      });
    },
    //打印
    showtext() {
      this.$refs.printtext.style.display = "block";
      setTimeout(() => {
        this.$refs.printtext.style.display = "none";
      }, 500);
    },
    //导出数据
    excelexport() {
      if (!this.selection.length) {
        this.$message.error("请先选择需要导出的数据");
        return false;
      }
      let loading = this.$loading();
      let idarr = this.selection.map((item) => {
        return item.ca_id;
      });
      let ca_id = idarr.toString();
      doctor_fee
        .exportCashoutList({ ca_id })
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url;
            location.href = host;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
  activated() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.search {
  display: flex;
  justify-content: space-between;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0 0;
  .item {
    margin-right: 14px;
    margin-bottom: 20px;
  }
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin-bottom: 12px;
  .price {
    display: flex;
    align-items: center;
    .priceitem {
      width: 200px;
      border-right: solid 1px #e1e3e9;
    }
    .priceitem:before {
      content: "";
    }
  }
  .gray {
    font-size: 12px;
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 600;
    color: #f24e33;
  }
}
.audit_sheet {
  width: 800px;
  border: 1px solid #333;
  border-bottom: 0px solid #333;
  font-family: SimSun;
  margin-bottom: 5px;
  .item {
    border-bottom: 1px solid #333;
    display: flex;
    line-height: 35px;
    text-align: center;
  }
  .title {
    font-size: 22px;
    padding: 3px 0;
    font-weight: 700;
    justify-content: center;
  }
  .border_right {
    border-right: 1px solid #333;
  }
  .width_23 {
    width: 23%;
    box-sizing: border-box;
  }
  .width_50 {
    width: 50%;
    box-sizing: border-box;
  }
  .width_27 {
    width: 27%;
    box-sizing: border-box;
  }
}
</style>
